exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li {\n  cursor: pointer; }\n\n.brand {\n  float: left; }\n\n.menu {\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/title-bar/title-bar.component.scss
// module id = ../../../../../src/app/title-bar/title-bar.component.scss
// module chunks = main